// extracted by mini-css-extract-plugin
export default {"fullWidth":"lp-z","image":"mp-z","lazyLoadPicture":"np-z","lazyLoadSpinner":"op-z","lazyLoadSpin":"pp-z","lazyLoadImage":"qp-z","hasStyledAspectRatio":"rp-z"};